import { HARMONIZED_DATA_FILES } from 'constants/constants';
import { getSubmittableFileDefinitions } from 'utils/dictionaryHelpers';
import CasesToolbar from './CasesToolbar';
import BiospecimenToolbar from './BiospecimenToolbar';
import TransactionsToolbar from './TransactionsToolbar';
import AnnotationsToolbar from './AnnotationsToolbar';
import DataFilesToolbar from './DataFilesToolbar';
import ClinicalToolbar from './ClinicalToolbar';
import QCEntitiesToolbar from './QCEntitiesToolbar';
import QCSummaryToolbar from './QCSummaryToolbar';

export { TransactionsToolbar, QCSummaryToolbar };

export function ToolbarRegistry(path, entity, defs) {
  if (path === 'qc') return QCEntitiesToolbar;

  const submittableToToolbar = getSubmittableFileDefinitions({ defs })
    .reduce((acc, d) => ({ ...acc, [d.id]: DataFilesToolbar }), {});

  const biospecimenToToolbar = defs
    .filter(d => d.category === 'biospecimen')
    .reduce((acc, d) => ({ ...acc, [d.id]: BiospecimenToolbar }), {});

  const clinicalToToolbar = defs
    .filter(d => d.category === 'clinical')
    .reduce((acc, d) => ({ ...acc, [d.id]: ClinicalToolbar }), {});

  const harmonizedToToolbar = HARMONIZED_DATA_FILES
    .reduce((acc, type) => ({
      ...acc,
      [type]: DataFilesToolbar,
    }), {});

  const entityToToolbar = {
    ...harmonizedToToolbar,
    ...submittableToToolbar,
    ...biospecimenToToolbar,
    ...clinicalToToolbar,
    case: CasesToolbar,
    annotation: AnnotationsToolbar,
  };
  return entityToToolbar[entity] || CasesToolbar;
}
